export default "__VITE_PUBLIC_ASSET__a77a7046__"